import React from 'react';
import isEqual from 'react-fast-compare';
import Toggle from 'theme/Toggle';

const ThemedToggle = ( { onPress = null, checked = false, text = null, children  } ) => {
	
	return (
		<Toggle
			checked={ checked }
			onPress={ onPress }
			text={ text || children }
		/>
	)
}

export default React.memo( ThemedToggle, isEqual );
